module.exports = __webpack_public_path__ + "legacy-application-modernization.2z_msJVi.svg";